// Core imports
import * as React from 'react';
import WarrantyClaimService from 'src/services/warrantyClaim/warrantyClaimService';
import DamageClaimService from 'src/services/DamageClaim/DamageClaimService';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import OrderExtraPartClaimInfo from 'src/components/OrderExtraPart/OrderExtraPartClaimInfo';
import OrderExtraPartServiceInfo from 'src/components/OrderExtraPart/OrderExtraPartServiceInfo';
import OrderExtraPartMoreInfo from 'src/components/OrderExtraPart/OrderExtraPartMoreInfo';
import OrderExtraPartPartInfo from 'src/components/OrderExtraPart/OrderExtraPartPartInfo';
import OrderExtraPartsubmittedPage from 'src/components/OrderExtraPart/OrderExtraPartsubmittedPage';
import './OrderExtraPart.scss';
import Button from '@material-ui/core/Button';
import { goToHome, goToPartClaim } from 'src/utils/navigation';
import env from 'src/shared/env';
import { HalfCircleSpinner } from 'react-epic-spinners';

import {
  UsphoneNumberRegEx,
  emailcapsRegEx,
  commentsRegEx,
  NonkeycharacterRegEx
} from 'src/utils/RegexUtils';

import i18n from 'src/translation/i18n';
import UserModel from 'src/model/user.model';
import AlertMessage from 'src/components/WarrantyClaimForm/AlertMessage';

import ClaimDetailsModel from 'src/model/ClaimDetails.model';
import ClaimPartDetails from 'src/model/ClaimPartDetails.model';

interface IDamagedProps {
  t?: any;
  userData: UserModel;
  cResubmitDetails: ClaimPartDetails;
  RSClaimDetails: ClaimDetailsModel;
  ResetDamagVW: boolean;
  backToDashBoard: () => void;
}

class OrderExtraPart extends React.Component<
  IDamagedProps,
  IDamageClaimFormState
> {
  public uploadQueue: any[] = [];
  public deletepic: any[] = [];
  public selectRef: any = null;
  public Minimumpicture: number =
    env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 4 : 3;
  constructor(props: any) {
    super(props);
    this.state = {
      DamageData: {
        DamageaccountNumber: this.props?.userData?.accountId
          ? this.props.userData.accountId
          : '',
        DamageclaimNumber: '',
        DamagecustomerNumber: localStorage.getItem('activeAccount'),
        Damagerefno: '',
        Damageerrormsg: '',
        Damageerrormsgshow: false,
        picspinnerspinning: false,
        Erroredpic: false,
        DamagepartDetails: [{ ...this.DamagepartBase }],
        DamageservicerEmail: '',
        DamageservicerPhone: '',
        submittedsuccessfully: false,
        Ddupimage: false,
        DamageAdditionalComment: ''
      },
      Damageerrors: {
        DamagerefnoError: false,
        DamageservicerEmailError: false,
        DamageservicerPhoneError: false,
        DamageAdditionalCommentError: false,
        DamagepartErrors: [{ ...this.DamagepartError }],
      },
      isSubmitButtonDisabled: false
    };
  }
  private DamagepartError = {
    DamagepartNumberError: false,
    DamageInvoiceNumberError: false,
    DamagequantityError: false,
    DamagequantityReceivedError: false,
    DamageUnitpriceError: false,
    DamageTotalpriceError: false,
    DescriptionOfDamageError: false
  };

  
  private DamagepartBase = {
    DpartNumber: '',
    Dquantity: 0,
    Dquantityr: 0,
    Dprice: 0,
    Dtotalprice: '',
    Dunitprice: '',
    Dunitpricenum: 0,
    DinvoiceNumber: 0,
    Dtempquantity: 1,
    Dtempquantityr: 1,
    DamageDescription: '',
    Dquantityshow: '',
    DquantityReceivedShow: '',
    Dpriceshow: '',
    Dcount: 0,
    Dpicofpart: [''],
    DfileArray: [''],
    Dtempfilearray: [''],
    Duploadedfile: [''],
    Dimagepreview: [''],
    DshowUploadModal: false,
    Dtestpartnum: '',
    Dmfg: '',
    DwholePartNumber: '',
    Dfileobject: [''],
    Dpictureofparts: [
      {
        Dfilename: '',
        Dspinner: '',
        Dfile: [''],
        Dimagecount: 0,
        Dimgfail: '',
        Dimgthumbnail: ''
      }
    ],
    DpartSelectedDetails: [
      {
        invoiceNumber: 'Select Invoice',
        partNumber: '',
        availableQuantity: 0,
        unitPrice: 0,
        purchaseDate: '',
        manufacturerCode: '',
        invoiceDate: '',
        wholePartNumber: ''
      }
    ],
    DInvoiceoption: {},
    DpartInvoiceList: [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false,
        wholePartNumber: ''
      }
    ]
  };

  // Backend data //

  private Backendata = () => {
    const DamageData: any = { ...this.state.DamageData };
    const DpartDetails: any[] = [];
    DamageData.DamagepartDetails.map((value: any, i: number) => {
      DpartDetails.push({
        descriptionOfDamage: value.DamageDescription
          ? value.DamageDescription
          : '',
        invoiceNumber: value.DinvoiceNumber ? value.DinvoiceNumber : null,
        manufacturerCode: value.Dmfg ? value.Dmfg : '',
        partLineIndex: i + 1,
        partNumber: value.DpartNumber ? value.DpartNumber.toUpperCase() : '',
        wholePartNumber: value.DwholePartNumber ? value.DwholePartNumber : '',
        pictureOfPart: value.Dcount >= this.Minimumpicture ? 'Y' : 'N',
        purchaseDate: null,
        qtyOrdered: Number(value.Dquantity),
        qtyReceived: Number(value.Dquantityr),
        replacementDate: 0,
        replacementInvoice: '',
        totalPrice: value.Dprice,
        unitPrice: value.Dunitpricenum
      });
    });
    const DamageClaimData: any = {
      accountNumber: DamageData.DamagecustomerNumber,
      brand: '',
      claimResubmit: '',
      previousClaimNumber: '',
      claimNumber: DamageData.DamageclaimNumber,
      customer: {
        address: '',
        city: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        state: '',
        zipCode: ''
      },
      customerComplaint: '',
      locationForReturn: '',
      failedDate: 0,
      installedDate: 0,
      isReturned: '',
      modelBrand: '',
      modelNumber: '',
      part: DpartDetails,
      purchaseCost: 0,
      referenceNumber: DamageData.Damagerefno,
      repairDate: 0,
      requestReturnTag: '',
      serialNumber: '',
      servicePerformed: '',
      servicerEmail: DamageData.DamageservicerEmail,
      servicerPhoneNumber: DamageData.DamageservicerPhone
        ? DamageData.DamageservicerPhone
        : '',
      source: 'NS3DAM',
      supplierInvoiceNumber: '',
      supplierInvoiceDate: 0,
      supplierOrderNumber: '',
      supplierPoNumber: '',
      trackingNumber: '',
      incidentNumbers: '',
      productTypes: '',
      additionalComment:DamageData.DamageAdditionalComment,
      claimType:'orderHasExtraPart'
    };
    // console.log(DamageClaimData,DamageData, 'DamageClaimData');
    if (this.props.RSClaimDetails) {
      DamageClaimData.claimResubmit = 'Y';
      DamageClaimData.previousClaimNumber = this.props.RSClaimDetails.claimNumber;
      const pDetails = this.props.RSClaimDetails.partNumber.split(' ');
      DamageClaimData.part[0].manufacturerCode = pDetails[0];
      DamageClaimData.part[0].wholePartNumber = this.props.RSClaimDetails.partNumber;
    }
    return DamageClaimData;
  };

  //  getting ClaimNumber  //

  public componentDidMount = () => {
    this.setState({
      isSubmitButtonDisabled: false
    });
    const sendClaimType="orderHasExtraPart";
    DamageClaimService.getNewClaimNumber(sendClaimType)
      .then((claimNumber: any) => {
        // let objDamag: any = null;
        if (this.props.RSClaimDetails) {
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageclaimNumber: claimNumber.data
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageservicerEmail: this.props.RSClaimDetails.servicerEmail
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageservicerPhone: this.props.RSClaimDetails.servicerPhoneNumber
            }
          });
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              Damagerefno: this.props.RSClaimDetails.yourReferenceNumber
            }
          });

          const index: number = 0;
          const DamagepartState = {
            ...this.state.DamageData.DamagepartDetails[index]
          };
          const wholeerror = {
            ...this.state.Damageerrors.DamagepartErrors[index]
          };
          const DamagepartDetails = [
            ...this.state.DamageData.DamagepartDetails
          ];
          const Damageparterrors = [
            ...this.state.Damageerrors.DamagepartErrors
          ];

          const pDetails = this.props.RSClaimDetails.partNumber.split(' ');
          const promise1 = new Promise((resolve, reject) => {
            WarrantyClaimService.getPartnumber(
              'N',
              pDetails[pDetails.length - 1],
              true
            )
              .then(response => {
                let selectedPartDetails: any[] = [];
                const partInvoiceLst: any[] = [];
                const partInvoiceShow: any[] = [];
                selectedPartDetails = response && response['data'];
                if (selectedPartDetails && selectedPartDetails.length > 0) {
                  // console.log('selectedPartDetails', selectedPartDetails);
                  DamagepartState['DpartSelectedDetails'] = selectedPartDetails;

                  selectedPartDetails.map(a => {
                    return partInvoiceLst.push({
                      value:
                        a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                      label:
                        a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                      invnum: a.invoiceNumber,
                      isDisabled: a.availableQuantity <= 0 ? true : false,
                      quantity: a.availableQuantity,
                      unitPrice: a.unitPrice
                    });
                  });
                  DamagepartState['DpartInvoiceList'] = partInvoiceLst;
                }
                resolve('csInvoiceList');
              })
              .catch(error => {
                // console.log(error);
                DamagepartState['DpartSelectedDetails'] = [];
                resolve('csInvoiceList');
              });
          });
          Promise.all([promise1]).then((values: any) => {
            const cspInvoiceList: any = DamagepartState['DpartInvoiceList'];
            // console.log('Promise all', DamagepartState['DpartInvoiceList']);
            // debugger;
            const iIndex = cspInvoiceList.findIndex(
              (p: any) =>
                p.invnum === this.props.RSClaimDetails.originalInvoiceNumber
            );

            DamagepartState[
              'DinvoiceNumber'
            ] = this.props.RSClaimDetails.originalInvoiceNumber;
            DamagepartState['Dprice'] =
              this.props.RSClaimDetails.totalPrice *
              this.props.RSClaimDetails.quantity *
              1;
            DamagepartState['Dpriceshow'] = this.getAmountFixedValue(
              this.props.RSClaimDetails.totalPrice *
                this.props.RSClaimDetails.quantity *
                1
            );
            DamagepartState['Dquantity'] =
              this.props.RSClaimDetails.quantity * 1;
            DamagepartState['Dquantityr'] =
              this.props.RSClaimDetails.quantityr * 1;
            DamagepartState['DInvoiceOption'] = {
              value: this.props.RSClaimDetails.originalInvoiceNumber,
              label: this.props.RSClaimDetails.originalInvoiceNumber,
              invnum: this.props.RSClaimDetails.originalInvoiceNumber,
              isDisabled: true
              // quantity: this.props.RSClaimDetails.quantity*1
            };

            DamagepartState['Dunitprice'] = this.getAmountFixedValue(
              this.props.cResubmitDetails.cspUnitPrice
            );
            DamagepartState[
              'Dunitpricenum'
            ] = this.props.cResubmitDetails.cspUnitPrice;
            // console.log('CSP Index', iIndex);
            if (iIndex > -1) {
              DamagepartState['Dtestpartnum'] = 'filled';
              DamagepartState['Dtempquantity'] = cspInvoiceList[iIndex].quantity;
              DamagepartState['Dtempquantityr'] = cspInvoiceList[iIndex].quantityr;
            }
            DamagepartState[
              'damageDescription'
            ] = this.props.RSClaimDetails.damageDescription;
            DamagepartState.DamageDescription = this.props.RSClaimDetails.damageDescription;
            wholeerror.DamageInvoiceNumberError = false;
            wholeerror.DamagequantityError = false;
            DamagepartState.DpartNumber = pDetails[pDetails.length - 1];

            DamagepartDetails[index] = DamagepartState;
            DamagepartDetails[
              index
            ].DamageDescription = this.props.RSClaimDetails.damageDescription;
            DamagepartDetails[index][
              'damageDescription'
            ] = this.props.RSClaimDetails.damageDescription;
            this.setState({
              DamageData: {
                ...this.state.DamageData,
                DamagepartDetails
              }
            });
             // Validation - if tempquantity is 0 then  do not allow to resubmit claim
            /* if(DamagepartState['Dtempquantity']<=0){
              const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
              const error = true;
              error
              ? (quantityerror[index].DamagequantityError = error)
              : (quantityerror[index].DamagequantityError = false);
              this.setState({
                Damageerrors: {
                  ...this.state.Damageerrors,
                  DamagepartErrors: [...quantityerror]
                }
              });
             } */

             if(DamagepartState['Dtempquantityr']<=0){
              const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
              const error = true;
              error
              ? (quantityerror[index].DamagequantityError = error)
              : (quantityerror[index].DamagequantityError = false);
              this.setState({
                Damageerrors: {
                  ...this.state.Damageerrors,
                  DamagepartErrors: [...quantityerror]
                }
              });
             }
          });
        } else {
          this.setState({
            DamageData: {
              ...this.state.DamageData,
              DamageclaimNumber: claimNumber.data
            }
          });
        }
      })
      .catch((error: any) => console.log(error));
  };

  // go to damage claim //
  private getAmountFixedValue = (amount: any) => {
    const amountVal = Number(amount);
    if (amountVal) {
      return `$${amountVal.toFixed(2)}`;
    }
    return '$0.00';
  };
  private goToDamageClaim = () => {
    WarrantyClaimService.getClaimNumber().then((claimNumber: any) => {
      this.setState({
        DamageData: {
          ...this.state.DamageData,
          DamageclaimNumber: claimNumber.data
        }
      });
    });
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        submittedsuccessfully: false
      }
    });
  };

  //  Reference Number //


  //  Servicer Email  //

  private handleDamageserviceremail = (event: any) => {
    const { name, value } = event.target;
    const error =
      !emailcapsRegEx.test(value) || value.length > 50 || value === '';
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamageservicerEmail: value
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamageservicerEmailError: error
      }
    });
  };

  // Servicer Phone //

  private handleDamageservicerphone = (event: any) => {
    const { name, value } = event.target;
    const phonetest = value
      ? value
          .match(/\d+/g)
          .join('')
          .replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3')
      : '';
    const error = value ? !UsphoneNumberRegEx.test(phonetest) : false;

    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamageservicerPhone: phonetest
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamageservicerPhoneError: error
      }
    });
  };

  // Parts RELATED FUNCTIONS //

  // Handle part number  //

  private handleDamagePartNumber = (event: any, index: number) => {
    const { name, value } = event.target;
    const customerState = { ...this.state.DamageData };
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    const wholeerror = { ...this.state.Damageerrors.DamagepartErrors[index] };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];
    DamagepartState['DpartSelectedDetails'] = [];
    DamagepartState['DinvoiceNumber'] = 0;
    DamagepartState['Dprice'] = 0;
    DamagepartState['Dpriceshow'] = '$0.00';
    DamagepartState['Dquantity'] = 0;
    DamagepartState['Dquantityr'] = 0;
    DamagepartState['DInvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };

    DamagepartState['Dunitprice'] = '$0.00';
    DamagepartState['Dunitpricenum'] = 0;
    DamagepartState['Dtestpartnum'] = '';
    DamagepartState['Dtempquantity'] = 1;
    DamagepartState['Dtempquantityr'] = 1;
    wholeerror.DamageInvoiceNumberError = false;
    wholeerror.DamagequantityError = false;
    wholeerror.DamagequantityReceivedError = false;
    DamagepartState.DpartNumber = value;
    DamagepartDetails[index] = DamagepartState;
    Damageparterrors[index] = wholeerror;
    this.setState({
      DamageData: {
        ...this.state.DamageData,

        DamagepartDetails
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    });
    if (value.trim() !== '') {
      WarrantyClaimService.getPartnumber('N', value, false)
        .then(response => {
          let selectedPartDetails: any[] = [];
          const partInvoiceLst: any[] = [];
          const partInvoiceShow: any[] = [];
          selectedPartDetails = response && response['data'];
          DamagepartState['DpartSelectedDetails'] = selectedPartDetails;

          selectedPartDetails.map(a => {
            return partInvoiceLst.push({
              value: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              label: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              invnum: a.invoiceNumber,
              isDisabled: a.availableQuantity <= 0 ? true : false,
              quantity: a.availableQuantity,
              unitPrice: a.unitPrice
            });
          });
          DamagepartState['DpartInvoiceList'] = partInvoiceLst;

          if (partInvoiceLst.length === 0) {
            DamagepartState['DpartSelectedDetails'] = [];
            DamagepartState['DinvoiceNumber'] = 0;
            DamagepartState['Dprice'] = 0;
            DamagepartState['Dpriceshow'] = '$0.00';
            DamagepartState['Dunitpricenum'] = 0;
            DamagepartState['Dquantity'] = 0;
            DamagepartState['Dquantityr'] = 0;
            DamagepartState['DInvoiceOption'] = {
              value: 'Select Invoice',
              label: 'Select Invoice',
              invnum: 'Select Invoice',
              isDisabled: false
            };

            DamagepartState['Dunitprice'] = '$0.00';
            DamagepartState['Dtestpartnum'] = '';
            DamagepartState['Dtempquantity'] = 1;
            DamagepartState['Dtempquantityr'] = 1;
          }

          DamagepartState['Dtestpartnum'] = 'filled';
          DamagepartDetails[index] = DamagepartState;
          this.setState({
            DamageData: {
              ...this.state.DamageData,

              DamagepartDetails
            }
          });
        })
        .catch(error1 => {
          this.DpartnumError(index);
        });
    }
  };

  // handle partnum error //

  private DpartnumError = (index: number) => {
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    DamagepartState['DpartInvoiceList'] = [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false
      }
    ];
    DamagepartState['DpartSelectedDetails'] = [];
    DamagepartState['DinvoiceNumber'] = 0;
    DamagepartState['Dprice'] = 0;
    DamagepartState['Dpriceshow'] = '$0.00';
    DamagepartState['Dunitpricenum'] = 0;
    DamagepartState['Dquantity'] = 0;
    DamagepartState['Dquantityr'] = 0;
    DamagepartState['DInvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };

    DamagepartState['Dorgpurchasedate'] = '';
    DamagepartState['Dunitprice'] = '$0.00';
    DamagepartState['Dtestpartnum'] = '';
    DamagepartState['Dtempquantity'] = 1;
    DamagepartState['Dtempquantityr'] = 1;
    DamagepartState['Dmfg'] = '';
    DamagepartState['DwholePartNumber'] = '';

    DamagepartDetails[index] = DamagepartState;
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamagepartDetails
      }
    });
  };

  //   Handle invoice Number //

  private handleDamageinvoice = (inv: IDSelectOption, index: number) => {
    const customerState = { ...this.state.DamageData };
    const DamagepartState = {
      ...this.state.DamageData.DamagepartDetails[index]
    };
    DamagepartState.DinvoiceNumber = inv.invnum;
    const invnoerror = [...this.state.Damageerrors.DamagepartErrors];

    const DselectedPartDetails: IDPartSelectedDetails[] =
      DamagepartState['DpartSelectedDetails'];

    const selectedInvoice = DselectedPartDetails.filter(
      a => a.invoiceNumber === inv.invnum
    );
    // debugger;
    if (selectedInvoice && selectedInvoice.length > 0) {
      DamagepartState['invoiceNumber'] = inv.invnum;

      if (DamagepartState['DinvoiceNumber'] > 0) {
        DamagepartState['Dquantity'] = 1;
      }

      DamagepartState['Dtempquantity'] = selectedInvoice[0].availableQuantity;
      DamagepartState['Dtempquantityr'] = selectedInvoice[0].availableQuantity;
      DamagepartState['Dpriceshow'] = currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      DamagepartState['Dunitprice'] = currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      DamagepartState['Dunitpricenum'] = selectedInvoice[0].unitPrice;
      DamagepartState['Dprice'] = selectedInvoice[0].unitPrice;
      DamagepartState['Dmfg'] = selectedInvoice[0].manufacturerCode;
      DamagepartState['DwholePartNumber'] =
        selectedInvoice[0].manufacturerCode +
        ' ' +
        DamagepartState['DpartNumber'].toUpperCase();

      DamagepartState['Dtotalprice'] = selectedInvoice[0].unitPrice.toString();

      DamagepartState['DInvoiceOption'] = {
        value: inv.invnum,
        label: inv.invnum,
        invnum: inv.invnum,
        isDisabled: inv.isDisabled,
        quantity: inv.quantity,
        unitPrice: inv.unitPrice
      };
      DamagepartState['Dtempquantity'] = inv.quantity;
      DamagepartState['Dtempquantityr'] = inv.quantity;

      invnoerror[index].DamagequantityError = false;
      invnoerror[index].DamagequantityError = false;

      const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
      DamagepartDetails[index] = DamagepartState;
      DamagepartDetails[index].DInvoiceOption =
        DamagepartState['DInvoiceOption'];
      this.setState({
        DamageData: { ...customerState, DamagepartDetails },
        Damageerrors: {
          ...this.state.Damageerrors,
          DamagepartErrors: [...invnoerror]
        }
      });
      let error = false;
      let j;
      if (DamagepartDetails.length > 0) {
        for (j = 0; j < DamagepartDetails.length; j++) {
          if (j !== index) {
            if (
              DamagepartDetails[j].DpartNumber ===
              DamagepartState['DpartNumber']
            ) {
              if (
                DamagepartDetails[j].DinvoiceNumber ===
                DamagepartState['DinvoiceNumber']
              ) {
                error = false;

                DamagepartState['Dquantity'] = 0;
                DamagepartState['Dquantityr'] = 0;
                DamagepartState['Dpriceshow'] = '$0.00';
                DamagepartState['Dprice'] = 0;
                DamagepartState['Dunitprice'] = '$0.00';
                DamagepartState['Dunitpricenum'] = 0;
                break;
              }
            }
          }
        }

        error
          ? (invnoerror[index].DamageInvoiceNumberError = error)
          : (invnoerror[index].DamageInvoiceNumberError = false);

        DamagepartDetails[index] = DamagepartState;
        this.setState({
          DamageData: { ...customerState, DamagepartDetails },
          Damageerrors: {
            ...this.state.Damageerrors,
            DamagepartErrors: [...invnoerror]
          }
        });
      } else {
        invnoerror[index].DamageInvoiceNumberError = false;
        this.setState({
          DamageData: { ...customerState, DamagepartDetails },
          Damageerrors: {
            ...this.state.Damageerrors,
            DamagepartErrors: [...invnoerror]
          }
        });
      }
    }
  };
  // Handle quantity //

  private handleDamagequantity = (event: any, index: any) => {
    const { name, value } = event.target;
    const invalidChars = ['-', '+', 'e'];

    if (!invalidChars.includes(event.key) || event.which !== 8) {
      // debugger;
      event.preventDefault();
      const DamagepartState = {
        ...this.state.DamageData.DamagepartDetails[index]
      };
      const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
      const customerState = { ...this.state.DamageData };
      const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];

      const selectedPartDetails: IDPartSelectedDetails[] =
        DamagepartState['DpartSelectedDetails'];

      let error;
      DamagepartState.Dquantity = value;
      if (
        value === '' ||
        value < 0 ||
        value.includes('.') ||
        value === '.' ||
        value === 'e'
      ){
          error = true;
      }

    
      // Resubmit validation
      if(this.props.cResubmitDetails!==undefined){
       
        if(value === 0 ||
          value === '' ||
          value === '0' ||
          value < 0 ||
          value.includes('.') ||
          value === '.' ||
          value === 'e'){
            error = true;
          }
         
      }

      if (error === true) {
        DamagepartDetails[index] = DamagepartState;
      }

      error
        ? (quantityerror[index].DamagequantityError = error)
        : (quantityerror[index].DamagequantityError = false);

      DamagepartDetails[index] = DamagepartState;

      this.setState({
        DamageData: {
          ...this.state.DamageData,

          DamagepartDetails
        }
      });
      this.setState({
        DamageData: { ...customerState, DamagepartDetails },
        Damageerrors: {
          ...this.state.Damageerrors,
          DamagepartErrors: [...quantityerror]
        }
      });
    }
  };

  // Handle quantity //

  private handleDamagequantityReceived = (event: any, index: any) => {
    const { name, value } = event.target;
    const invalidChars = ['-', '+', 'e'];

    if (!invalidChars.includes(event.key) || event.which !== 8) {
      // debugger;
      event.preventDefault();
      const DamagepartState = {
        ...this.state.DamageData.DamagepartDetails[index]
      };
      const quantityerror = [...this.state.Damageerrors.DamagepartErrors];
      const customerState = { ...this.state.DamageData };
      const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];

      const selectedPartDetails: IDPartSelectedDetails[] =
        DamagepartState['DpartSelectedDetails'];

      let error;
      DamagepartState.Dquantityr = value;
      if (
        value === '' ||
        value < 0 ||
        value === "0" ||
        value.includes('.') ||
        value === '.' ||
        value === 'e'
      ){
          error = true;
        }

     
      // Resubmit validation
      if(this.props.cResubmitDetails!==undefined){
        if (value < DamagepartDetails[0].Dtempquantityr) {
          error = true;
        }
        if(value === '' ||
          value < 0 ||
          value.includes('.') ||
          value === '.' ||
          value === 'e'){
            error = true;
          }
      }

      if (error === true) {
        DamagepartDetails[index] = DamagepartState;
      }

      error
        ? (quantityerror[index].DamagequantityReceivedError = error)
        : (quantityerror[index].DamagequantityReceivedError = false);

      DamagepartDetails[index] = DamagepartState;

      this.setState({
        DamageData: {
          ...this.state.DamageData,

          DamagepartDetails
        }
      });
      this.setState({
        DamageData: { ...customerState, DamagepartDetails },
        Damageerrors: {
          ...this.state.Damageerrors,
          DamagepartErrors: [...quantityerror]
        }
      });
    }
  };

  //   Description of Damge   //

  private handleDamageDescription = (event: any, index: any) => {
    // debugger;
    const { name, value } = event.target;
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const damagedescriptionerror = [
      ...this.state.Damageerrors.DamagepartErrors
    ];
    const error =
      value.length > 250 ||
      !NonkeycharacterRegEx.test(value) ||
      !commentsRegEx.test(value) ||
      !/\S/.test(value);

    error
      ? (damagedescriptionerror[index].DescriptionOfDamageError = true)
      : (damagedescriptionerror[index].DescriptionOfDamageError = false);
    DamagepartDetails[index].DamageDescription = value;
    // DamagepartDetails[index].damageDescription=value;
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...this.state.Damageerrors,
        DamagepartErrors: [...damagedescriptionerror]
      }
    });
  };

  private handleAdditionalComment = (event: any) => {
    const { name, value } = event.target;
   
    const error = value ? value.length > 250 ||
    !NonkeycharacterRegEx.test(value) ||
    !commentsRegEx.test(value) ||
    !/\S/.test(value) : false;

    this.setState({
      DamageData: {
        ...this.state.DamageData,
        DamageAdditionalComment: value
      },
       Damageerrors: {
        ...this.state.Damageerrors,
        DamageAdditionalCommentError: error
      }
    });

  };

 
  //   Add new parts //

  private addPart = () => {
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        Ddupimage: false
      }
    });
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];

    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];

    const Newpart = {
      ...this.DamagepartBase
    };
    Damageparterrors.push({ ...this.DamagepartError });
    DamagepartDetails.push(Newpart);

    this.setState((prevState: any) => ({
      DamageData: {
        ...prevState.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...prevState.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    }));
  };

  /* remove part */
  private removePart = (index: number) => {
    const DamagepartDetails = [...this.state.DamageData.DamagepartDetails];
    const Damageparterrors = [...this.state.Damageerrors.DamagepartErrors];

    DamagepartDetails.splice(index, 1);
    Damageparterrors.splice(index, 1);
    this.setState((prevState: any) => ({
      DamageData: {
        ...prevState.DamageData,
        DamagepartDetails
      },
      Damageerrors: {
        ...prevState.Damageerrors,
        DamagepartErrors: Damageparterrors
      }
    }));
  };

  // Required fiels //
  private Requiredfields = [
    'claimNumber',
    'customerNumber',
    'part.partNumber',
    'part.qtyReceived',
    'servicerEmail'
  ];

  // Checking for form submition //

  private Isformsubmit = () => {
    const damageData = this.Backendata();

    const result = this.Requiredfields.some(data => {

      const splitarr = data.split('.');
      let finaldata;

      switch (splitarr.length) {
        case 1:
          finaldata = damageData[splitarr[0]];
          break;

        case 2:
          if (splitarr[0] === 'part') {
            for (let i = 0; i < damageData.part.length; i++) {
              finaldata = damageData[splitarr[0]][i][splitarr[1]];
            }
          } else {
            finaldata = damageData[splitarr[0]][splitarr[1]];
          }
          break;
      }

      return finaldata === '' || finaldata === 0;
    });

    const errorsliststate = this.parterrormsg();


    return (
      result ||
      !this.IsError() ||
      errorsliststate
    );
  };
  // Part information error check //

  private parterrormsg = () => {
    const errorslist = [
      'DamagepartNumberError',
      'DamageInvoiceNumberError',
      'DamagequantityError',
      'DamagequantityReceivedError'
    ];
    const damageparterrorlist = [...this.state.Damageerrors.DamagepartErrors];
    let errorsliststate = false;
    damageparterrorlist.forEach((item: any) => {
      for (const key in item) {
        if (errorslist.includes(key) && item[key] === true) {
          errorsliststate = true;
        }
      }
    });
    return errorsliststate;
  };

  // Error checking form //

  private IsError = () => {
    const filteredkeys = Object.keys(this.state.Damageerrors).map(
      key => this.state.Damageerrors[key]
    );
   /* if(this.state.DamageData.DamageIsPackageDeliverd===""){
      filteredkeys[4] = true;
    }
    if(this.state.DamageData.DamageIsPackageDeliverd!=="" && this.state.DamageData.DamageNoPackageReceived===0 ){
      filteredkeys[5] = true;
    } */


      if(this.state.DamageData.DamageAdditionalComment===""){
        filteredkeys[3] = true;
      }
    
    filteredkeys[4] = false;
    return filteredkeys.every(value => value === false);
  };

  //   Submit Damage Claim //
  private ProcessClaimData = (damagClaimData: any) => {
    this.setState({
      isSubmitButtonDisabled: true
    });
    DamageClaimService.SubmitNewTypesClaim(damagClaimData)
      .then((response: any) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState({
          DamageData: {
            ...this.state.DamageData,
            submittedsuccessfully: true
          }
        });
      })
      .catch((error: any) => {
        this.setState({
          isSubmitButtonDisabled: false
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState({
          DamageData: {
            ...this.state.DamageData,
            Damageerrormsgshow: true,
            Damageerrormsg: error.response.data.message
          }
        });
      });
  };
  private submitClaim = () => {
    const damagClaimData = this.Backendata();
    // debugger;
    if (this.Isformsubmit()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.setState({
        DamageData: {
          ...this.state.DamageData,
          Damageerrormsgshow: true
        }
      });
    } else if (damagClaimData.claimResubmit === '') {
       this.ProcessClaimData(damagClaimData);
    } else {
      DamageClaimService.checkClaimSubmitted(damagClaimData).then(
        (result: any) => {
         
          // console.log(result.data);
          if (result.data) {
            // debugger;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.setState({
              DamageData: {
                ...this.state.DamageData,
                Damageerrormsg:
                  'This claim has already been resubmitted. Please review status under "Claim Status".',
                Damageerrormsgshow: true,
                submittedsuccessfully: false
              }
            });
          } else {
            console.log("=== Claim Ready to Submit ==");
            // this.ProcessClaimData(damagClaimData);
          }
        }
      );
    }
  };
  private closemsg = () => {
    this.setState({
      DamageData: {
        ...this.state.DamageData,
        Damageerrormsgshow: false,
        Erroredpic: this.state.DamageData.Erroredpic === true ? false : false,
        picspinnerspinning:
          this.state.DamageData.picspinnerspinning === true ? false : false,
        Ddupimage: false
      }
    });
  };

  public render() {
    return (
      <React.Fragment>
          
        {this.state.DamageData.submittedsuccessfully ? (
          <OrderExtraPartsubmittedPage
            claimNumber={this.state.DamageData.DamageclaimNumber}
            gotodamageClaim={this.goToDamageClaim}
            backToDashBoard={this.props.backToDashBoard}
          />
        ) : (
          <React.Fragment>
                  
          <form className="rp-Damage-claim-form" id="mydamageclaimForm">
            {this.Isformsubmit() ||
            this.state.DamageData.Damageerrormsg !== '' ? (
              <AlertMessage
                display={
                  this.state.DamageData.Damageerrormsgshow === true
                    ? true
                    : this.state.DamageData.Erroredpic ||
                      this.state.DamageData.picspinnerspinning === true
                    ? true
                    : this.state.DamageData.Ddupimage === true
                    ? true
                    : false
                }
                handleclose={this.closemsg}
                Message={
                    this.state.DamageData.Damageerrormsg !== ''
                    ? this.state.DamageData.Damageerrormsg
                    : this.parterrormsg() === true || !this.IsError()
                    ? `${i18n.t('damageClaim.pleasereviewandcorrect')}`
                    : this.state.DamageData.Ddupimage === true
                    ? `${i18n.t('damageClaim.dupimage')}`
                    : `${i18n.t('damageClaim.pleasereview')}`
                }
              />
            ) : (
              ''
            )}

            <OrderExtraPartClaimInfo
              DamageCustomerNumber={this.state.DamageData.DamagecustomerNumber}
              DamageClaimNumber={this.state.DamageData.DamageclaimNumber}
              DamageErrorlist={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
            />

            <OrderExtraPartPartInfo
              DamagePartInfo={...this.state.DamageData.DamagepartDetails}
              DamagePartErrorlist={this.state.Damageerrors.DamagepartErrors}
              handleDamagePartNumber={this.handleDamagePartNumber}
              handleDamageinvoice={this.handleDamageinvoice}
              handleDamagequantity={this.handleDamagequantity}
              handleDamagequantityReceived={this.handleDamagequantityReceived}
              addPart={this.addPart}
              removePart={this.removePart}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
            />

            <OrderExtraPartMoreInfo
              DamageAdditionalComment={this.state.DamageData.DamageAdditionalComment}
              DamageErrorlistservice={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
              handleAdditionalComment={this.handleAdditionalComment}
            />

            <OrderExtraPartServiceInfo
              DamageservicerEmail={this.state.DamageData.DamageservicerEmail}
              DamageservicerPhone={this.state.DamageData.DamageservicerPhone}
              DamageErrorlistservice={this.state.Damageerrors}
              DamageErrormsgshow={this.state.DamageData.Damageerrormsgshow}
              handleDamageserviceremail={this.handleDamageserviceremail}
              handleDamageservicerphone={this.handleDamageservicerphone}
            />

            <div className="data-row buttons d-flex">
              <Button variant="contained" onClick={this.submitClaim} disabled={this.state.isSubmitButtonDisabled}>
                {i18n.t('partClaim.submitClaim')}
              </Button>
              {this.state.isSubmitButtonDisabled &&
              <HalfCircleSpinner
                color="#0b4da2"
                size={30}
                style={{
                  textAlign: 'center',
                  display: 'inline-block',
                  padding: '5px'
                }}
              />
              }
            </div>
          </form>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default OrderExtraPart;

interface IDamageClaimFormState {
  DamageData: {
    DamageaccountNumber: string;
    DamagecustomerNumber: string;
    DamageclaimNumber: string;
    Damagerefno: string;
    Damageerrormsg: string;
    Damageerrormsgshow: boolean;
    picspinnerspinning: boolean;
    Erroredpic: boolean;
    submittedsuccessfully: boolean;
    DamageservicerEmail: string;
    DamageservicerPhone: string;
    Ddupimage: boolean;
    DamagepartDetails: IDamagePartDetails[];
    DamageAdditionalComment: string;

  };
  Damageerrors?: IDamageFormErrors;
  isSubmitButtonDisabled:boolean;
}
interface IDamageFormErrors {
  DamageservicerPhoneError: boolean;
  DamageservicerEmailError: boolean;
  DamagerefnoError: boolean;
  DamageAdditionalCommentError: boolean;
  DamagepartErrors: IDamagepartErrors[];
}
interface IDamagepartErrors {
  DamagepartNumberError: boolean;
  DamageInvoiceNumberError: boolean;
  DamagequantityError: boolean;
  DamagequantityReceivedError: boolean;
  DamageUnitpriceError: boolean;
  DamageTotalpriceError: boolean;
  DescriptionOfDamageError: boolean;
}

interface IDamagePartDetails {
  DpartNumber: string;
  Dquantity: number;
  Dquantityr: number;
  Dprice: number;
  Dunitpricenum: number;
  DinvoiceNumber: number;
  Dtempquantity: number;
  Dtempquantityr: number;
  DamageDescription: string;
  Dpriceshow: string;
  Dtotalprice: string;
  Dunitprice: string;
  DshowUploadModal: boolean;
  Dpicofpart?: any[];
  DfileArray?: any[];
  Dfileobject: any[];
  Dtempfilearray?: any[];
  Duploadedfile?: any[];
  Dimagepreview?: any[];
  Dcount: number;
  Dtestpartnum: string;
  Dmfg: string;
  DwholePartNumber: string;
  Dpictureofparts?: IDPictureofparts[];
  DpartSelectedDetails?: IDPartSelectedDetails[];
  DpartInvoiceList?: IDSelectOption[];
  DInvoiceOption?: IDSelectOption;
}
interface IDPictureofparts {
  Dfilename: string;
  Dfile: any[];
  Dspinner: string;
  Dimagecount: number;
  Dimgfail?: string;
  Dimgthumbnail?: string;
}
interface IDPartSelectedDetails {
  partNumber: string;
  availableQuantity: number;
  unitPrice: number;
  invoiceNumber: string;
  purchaseDate: string;
  manufacturerCode: string;
  invoiceDate: string;
  wholePartNumber: string;
}
interface IDSelectOption {
  value: any;
  label: any;
  invnum: any;
  isDisabled: boolean;
  quantity?: any;
  unitPrice?: any;
}
